

























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Picker extends Vue {
  @Prop({ required: true })
  show!: boolean;
  @Prop()
  pickerItem!: Array<object>;

  handleHidePicker() {
    this.$emit("hide");
  }
}
